import { Controller, useFormContext } from "react-hook-form";
import { RadioTileGroup, RadioTileGroupProps } from "./radio-tile-group";

export function ControlledRadioTileGroup<T extends string | number | boolean>(
  props: Omit<RadioTileGroupProps<T>, "onValueChange" | "errorMessage"> & {
    name: string;
  },
) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => (
        <RadioTileGroup
          {...field}
          onValueChange={field.onChange}
          {...props}
          errorMessage={fieldState?.error?.message}
          isInvalid={!!fieldState?.error?.message}
        />
      )}
    />
  );
}
